// extracted by mini-css-extract-plugin
export default {"default":"DescriptionItem-module__default--rAYpS","compact":"DescriptionItem-module__compact--AMnnu"};